import PaymentMethodsIcons from './PaymentMethodsIcons'

interface CardDiscountButtonProps {
  frequency: string
  bgImage: string
  category: string
  discount: string
  btnAction: () => void
  paymentMethods: {
    wayni: string
    mastercard: string
    gpay: string
  }
}

const CardDiscountButton = ({
  frequency,
  bgImage,
  category,
  discount,
  btnAction,
  paymentMethods
}: CardDiscountButtonProps) => (
  <button
    type='button'
    className='rounded-lg flex leading-[120%] flex-col relative shadow-card-benefits text-left hover:shadow-card-benefits-hover transition min-w-40 w-40 duration-500 ease-in-out'
    onClick={btnAction}
  >
    <div className='flex items-start min-h-[106px] w-full rounded-t-lg bg-discount-images'>
      <p className='bg-green-100 rounded-tl-[0.45rem] text-[#08724C] text-2xs font-bold inline-block m-0 px-2 py-1 absolute top-0 left-0 rounded-br-lg'>
        {frequency}
      </p>
      <img
        className='object-cover w-full h-full rounded-t-lg -z-1'
        src={bgImage}
        alt=''
      />
    </div>
    <div className='p-2 bg-[#FFF] h-full justify-between flex flex-col w-full rounded-b-lg'>
      <div>
        <p className='font-bold text-gray-900 text-2xs'>{category}</p>
        <p className='text-base font-bold text-black mb-1'>{discount}</p>
      </div>
      <div className='flex items-center max-h-14 mt-auto'>
        <PaymentMethodsIcons paymentMethods={paymentMethods} />
      </div>
    </div>
  </button>
)

export default CardDiscountButton

export const CardDiscountBg = ({ frequency, bgImage, isDetail = false }) => (
  <div className='rounded-lg flex flex-col relative text-left'>
    <div className='flex items-start min-h-[106px] w-full rounded-lg bg-discount-images'>
      <p className='bg-green-100 rounded-tl-lg text-[#08724C] text-2xs font-bold inline-block m-0 p-2 absolute top-0 left-0 rounded-br-lg md:z-2'>
        {frequency}
      </p>
      <img
        className={`object-cover w-full h-full ${
          isDetail ? 'rounded-lg' : 'rounded-t-lg'
        } -z-1 md:z-0`}
        src={bgImage}
        alt=''
      />
      <div className='rounded-lg hidden w-full h-full bg-discount-images absolute top-0 md:inline md:z-1' />
    </div>
  </div>
)
